import { useTranslation } from 'react-i18next';
import { Heading } from 'components/Typography';
import { Button } from 'components/Button';
import { formatPhoneNumber } from 'utils/phoneNumber';
import { useFlags } from 'launchdarkly-react-client-sdk';

type Props = {
  onContinueToSchedule: () => void;
  phoneNumber: string;
};

export const OfferPhoneCall: React.FC<Props> = ({ onContinueToSchedule, phoneNumber }) => {
  const { t } = useTranslation();
  const { isBookConsultationEnabled } = useFlags();

  return (
    <>
      <Heading level="h2" className="mb-16">
        {t('livePhoneCalls.call.title')}
      </Heading>
      <Heading level="h7" className="mb-40">
        {t('livePhoneCalls.call.subtitle')}
      </Heading>
      <Button size="lg" className="sm-d:w-full" as="a" href={`tel:+1${phoneNumber}`}>
        {t('livePhoneCalls.call.button', { phoneNumber: formatPhoneNumber(phoneNumber) })}
      </Button>
      {isBookConsultationEnabled && (
        <>
          <hr className="w-full my-64 sm-d:my-40 border-black-200" />
          <Heading level="h2" className="mb-16">
            {t('livePhoneCalls.schedule.title')}
          </Heading>
          <Heading level="h7" className="mb-40">
            {t('livePhoneCalls.schedule.subtitle')}
          </Heading>
          <Button size="lg" className="mb-64 sm-d:mb-40 sm-d:w-full" onClick={onContinueToSchedule}>
            {t('livePhoneCalls.schedule.button')}
          </Button>
        </>
      )}
    </>
  );
};
